import { registerBundledOAuthFlowLoaders } from "../../upstream/packages/ai/src/auth/oauth/load.ts";

/** Upstream's variable import is intentionally invisible to bundlers. Register
 * explicit lazy chunks while keeping each provider's own flow and fallback. */
export function registerBrowserOAuthFlows(): void {
	registerBundledOAuthFlowLoaders({
		anthropic: async () => (await import("../../upstream/packages/ai/src/auth/oauth/anthropic.ts")).anthropicOAuth,
		openaiCodex: async () => (await import("../../upstream/packages/ai/src/auth/oauth/openai-codex.ts")).openaiCodexOAuth,
		openaiChatGPT: async () => (await import("../../upstream/packages/ai/src/auth/oauth/openai-chatgpt.ts")).openaiChatGPTOAuth,
		githubCopilot: async () => (await import("../../upstream/packages/ai/src/auth/oauth/github-copilot.ts")).githubCopilotOAuth,
		openrouter: async () => (await import("../../upstream/packages/ai/src/auth/oauth/openrouter.ts")).openRouterOAuth,
		kimiCoding: async () => (await import("../../upstream/packages/ai/src/auth/oauth/kimi-coding.ts")).kimiCodingOAuth,
		meta: async () => (await import("../../upstream/packages/ai/src/auth/oauth/meta.ts")).metaOAuth,
		xai: async () => (await import("../../upstream/packages/ai/src/auth/oauth/xai.ts")).xaiOAuth,
		radius: async (options) => (await import("../../upstream/packages/ai/src/auth/oauth/radius.ts")).createRadiusOAuth(options),
	});
}
